import type { Note } from '@src/notes/domain/Note';
import { NotesClient } from '@src/notes/services/NotesClient';
import { useQuery } from '@tanstack/react-query';

export const useFindAllNotesForPermit = (permitId: string) => {
  const {
    data: notes = [],
    isLoading,
    refetch,
  } = useQuery<Note[]>({
    queryKey: ['notes.findAllNotesForPermit', { permitId }],
    queryFn: () => NotesClient.findAllForPermit(permitId),
  });

  return {
    notes,
    isLoading,
    refetch,
  };
};
